import React from "react"
import {
  TransitionGroup,
  Transition as ReactTransition,
} from "react-transition-group"
import { useLocation } from "@reach/router"

const DURATION = 500

type TransitionStateKeys =
  | "entering"
  | "entered"
  | "exiting"
  | "exited"
  | "unmounted"

type TransitionStates = {
  [key in TransitionStateKeys]: React.CSSProperties
}

const transitionStyles: TransitionStates = {
  entering: {
    position: "absolute",
    opacity: 0,
  },
  entered: {
    transition: `opacity ${DURATION}ms ease-out`,
    opacity: 1,
  },
  exiting: {
    transition: `all ${DURATION}ms ease-out`,
    opacity: 0,
  },
  exited: {},
  unmounted: {},
}

interface Props {
  children: any
}

const PageTransition: React.FC<Props> = ({ children }: Props) => {
  const location = useLocation()

  return (
    <TransitionGroup>
      <ReactTransition
        key={location.pathname}
        timeout={{
          enter: DURATION,
          exit: DURATION,
        }}
      >
        {(state: TransitionStateKeys): JSX.Element => (
          <div
            style={{
              maxWidth: "100vw",
              overflow: "hidden",
              ...transitionStyles[state],
            }}
          >
            {children}
          </div>
        )}
      </ReactTransition>
    </TransitionGroup>
  )
}

export default PageTransition
